<template>
    <div class="container">
        <div class="content">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small" label-width="64px">
                <el-form-item label="审批单名称">
                    <template #label>
                        <div class="label-con">
                            <div>审批单</div>
                            <div>名称</div>
                        </div>
                    </template>
                    <el-select v-model="searchForm.approvalFormId" @change="changeSelect('approvalFormId')" placeholder="请选择" clearable filterable>
                        <el-option
                            v-for="(item,index) in approvalNameList"
                            :key="item.id"
                            :label="item.templateName"
                            :value="item.id">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批流名称">
                    <template #label>
                        <div class="label-con">
                            <div>审批流</div>
                            <div>名称</div>
                        </div>
                    </template>
                    <el-select v-model="searchForm.approvalFlowName" @change="changeSelect('approvalFlowName')" placeholder="请选择" clearable filterable>
                        <el-option
                            v-for="(item,index) in processNameList"
                            :key="index"
                            :label="item"
                            :value="item">
                            </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批内容">
                    <el-input v-model="searchForm.approvalContent" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="审批编号">
                    <el-input v-model="searchForm.serialNumber" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="发起人" prop="name">
                    <div class="form-item-row">
                        <el-select v-model="startStatus" placeholder="请选择"  @change="changeStatus('start')" clearable class="row-select">
                            <el-option label="在职人员" value="A"></el-option>
                            <el-option label="离职人员" value="S"></el-option>
                        </el-select>
                        <el-select
                            v-model="searchForm.startUserId"
                            class="row-input"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="请输入搜索"
                            @clear="handleClear('start')"
                            :remote-method="(query) => searchUser(query, 'start')"
                            :loading="startUserLoading">
                            <el-option
                            v-for="item in startUserList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="审批人" prop="name">
                    <div class="form-item-row">
                        <el-select v-model="approverStatus" placeholder="请选择" @change="changeStatus('approver')" clearable class="row-select">
                            <el-option label="在职人员" value="A"></el-option>
                            <el-option label="离职人员" value="S"></el-option>
                        </el-select>
                        <el-select
                            v-model="searchForm.approverUserId"
                            class="row-input"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="请输入搜索"
                            @clear="handleClear('approver')"
                            :remote-method="(query) => searchUser(query, 'approver')"
                            :loading="approverUserLoading">
                            <el-option
                            v-for="item in approverUserList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="发起时间">
                    <eldate @changeData="changeData($event, 'startTime')" :dateData="startTime"></eldate>
                    <!-- <el-date-picker v-model="startTime" type="daterange" class="my-date-picker" range-separator="-" start-placeholder="年/月/日" end-placeholder="年/月/日" value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy/MM/dd" :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker> -->
                </el-form-item>
                <el-form-item label="完成时间">
                    <eldate @changeData="changeData($event, 'endTime')" :dateData="endTime"></eldate>
                    <!-- <el-date-picker v-model="endTime" type="daterange" class="my-date-picker" range-separator="-" start-placeholder="年/月/日" end-placeholder="年/月/日" value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy/MM/dd" :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker> -->
                </el-form-item>
                <el-form-item>
                    <div class="flex">
                        <div class="s-btn" @click="fetchData('search')">查询</div>
                        <div class="r-btn" @click="fetchData('reset')">重置</div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="line"></div>
            <div v-loading="loading">
                <div class="data-title">
                    <el-tabs v-model="currentTab" @tab-click="fetchData('search','noCount')" class="custom-tabs-apply">
                        <el-tab-pane v-for="(item, index) of tabsList" :label="item.name+'('+item.count+')'" :name="item.value" :key="index"></el-tab-pane>
                    </el-tabs>
                    <div class="title-btn">
                        <div class="title-btn-item" style="margin-right: 12px;" @click="batchExport()">
                            <img src="../../../assets/icon_daochu.png" style="width: 16px;height: 16px;" />
                            <div class="btn-l">批量导出</div>
                        </div>
                        <div class="title-btn-item" style="margin-right: 12px;" @click="batchPrint()">
                            <img src="../../../assets/icon_dayin.png" style="width: 16px;height: 16px;" />
                            <div class="btn-l">批量打印</div>
                        </div>
                    </div>
                </div>
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>


        <div id="print-content" style="width:0;height:0">
            <!-- <div id="print-content" style="position: absolute; left: 0; top: 0;bottom: 0; background-color: #fff;"> -->
            <div class="pop-up-content1">
                <!-- <base-staff-record-detail-print :currentRow="currentRow"></base-staff-record-detail-print> -->
            </div>
        </div>
        <div id="print-content1" style="display:none">
            <!-- <div id="print-content1" style="position: absolute; left: 0; top: 0; background: #FFF; z-index: 10;"> -->
            <!-- <base-staff-record-detail-print :currentRow="currentRow"></base-staff-record-detail-print> -->
            <!-- <base-staff-record-detail :currentRow="currentRow" :row="row1"></base-staff-record-detail> -->
        </div>

    </div>
</template>
<script>
    import mixinsList from '@/pages/officeApproval/approvalList/mixins/list.js'
    export default {
        name: 'approvalAllList',
        mixins: [mixinsList],
        components: {
        },
        data() {
            return {
                searchForm: {
                    approvalFormName: '',
                    approvalFormId: '',
                    approvalFlowName: '',
                    approvalContent: '',
                    serialNumber: '',
                    approverUserId: '',
                    startUserId: "",
                    approvalStatus: '0',
                    pageNo: 1,
                    pageSize: 10,
                    initiationType:-1, //发起类型：-1-取所有，1-我发起的，2-我参与过处理的，3-抄送给我的
                },
                startTime: [],
                endTime: [],
                columns: [
                    { type: 'selection', minWidth: '80' },
                    { label: '发起人', width: '170', 
                        render: (h, scope) => { 
                            let vv = ''
                            {
                            vv = <div class='text-left name'>
                                    {scope.row.startUser && scope.row.startUser.name}
                                </div>
                            }
                            return vv
                        }
                    },
                    { label: '审批单/审批流', prop: 'processDefinitionName', width: '300', 
                        render: (h, scope) => { 
                            let vv = ''
                            {
                            vv = <div class='text-left'>
                                    <div class='name'>{scope.row.processDefinitionName}</div>
                                    <div class='no'>编号：{scope.row.serialNumber}</div>
                                </div>
                            }
                            return vv
                        } 
                    },
                    { label: '内容', prop: 'name', minWidth: '250',
                        render: (h, scope) => { 
                            const items = scope.row.formContentItems.map(item => {
                                const contentDisplay = this.parseContent(item.content);
                                return h('div', { class: 'flex form-item-row' }, [
                                    h('div', { class: 'title' }, item.title + '：'),
                                    h('div', {
                                        class: 'text ellipsis',
                                        attrs: {
                                            title: contentDisplay
                                        }
                                    }, contentDisplay)
                                ]);
                            });
                            return h('div', { class: 'text-left' }, items);
                        } 
                     },
                    { label: '发起时间', prop: 'startTimeStr', width: '160' },
                    { label: '完成日期', prop: 'endTimeStr', width: '160' },
                    { label: '审批人', prop: 'recruitPost', minWidth: '140',
                    render: (h, scope) => { 
                            let vv = ''
                            {
                                vv = <div class='text-left'>
                                    <div class='ellipsis2' title={'当前：'+scope.row.currentApprover||'无'}>当前：{scope.row.currentApprover||'无'}</div>
                                    <div class='ellipsis2' title={'历史：'+scope.row.historyApprovers}>历史：{scope.row.historyApprovers}</div>
                                </div>
                            }
                            return vv
                        } 
                     },
                    {
                        label: '审批状态', width: '120',
                        // 1:正在处理 2:撤销 3:驳回 4:已结束
                        render: (h, scope) => {
                            let vv = ''
                            if (scope.row.businessStatus == '1' ) {
                                vv = <div><span class='point ing'></span>{scope.row.approvalStatus}</div>
                            } else if (scope.row.businessStatus == '2' ) {
                                vv = <div><span class='point dis'></span>{scope.row.approvalStatus}</div>
                            }else if (scope.row.businessStatus == '3' ) {
                                vv = <div><span class='point err'></span>{scope.row.approvalStatus}</div>
                            }else if (scope.row.businessStatus == '4' ) {
                                vv = <div><span class='point suc'></span>{scope.row.approvalStatus}</div>
                            }
                            return vv
                        }
                    },
                    {
                        label: '操作', prop: 'orgName', width: '130', fixed: 'right', align: 'center',
                        // this.print(scope.row, scope.$index)
                        render: (h, scope) => {
                            let vv = ''
                            {
                                vv = <div  class='flex' >
                                        <div class='link' onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看</div>
                                        <div class='link' onClick={() => { this.getPdf('export',scope.row.processInstanceId)  }} >导出</div>
                                        <div class='link' onClick={() => { this.getPdf('print',scope.row.processInstanceId) }} >打印</div>
                                    </div>
                                
                                return (
                                    <div>{vv}</div>
                                )
                            }
                        }
                    },
                ],
            }
        },
        created() {
        },
        activated() {
            if (this.$route.query.formId) {
                this.searchForm.approvalFormId = String(this.$route.query.formId)
                this.searchForm.approvalFormName = ''
                this.searchForm.approvalFlowName = ''
            }else if (this.$route.query.name) {
                this.searchForm.approvalFormId = ''
                this.searchForm.approvalFlowName = ''
                this.searchForm.approvalFormName = this.$route.query.name
            }else if (this.$route.query.pName) {
                this.searchForm.approvalFormId = ''
                this.searchForm.approvalFormName = ''
                this.searchForm.approvalFlowName = this.$route.query.pName
            }
            this.currentTab = "0"
            this.fetchData()
        },
        mounted() {

        },
        methods: {
            // 全部数据的审批详情
            lookDetail(val) {
                this.$router.push({ name: 'approvalAllDetail',query: { id: val.processInstanceId}})
            }
        }
    }
</script>
<style lang="scss" src="@/pages/officeApproval/approvalList/mixins/list.scss" scoped />
